export const CENTS_UNIT = 100;

const convertDecimalNumberToCents = decimalNumber => Math.round(Number(decimalNumber) * CENTS_UNIT);

export default convertDecimalNumberToCents;
